import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@fontsource-variable/red-hat-mono'
// Só baixa o arquivo quando o tema Ligado pede a fonte.
import '@fontsource-variable/plus-jakarta-sans'
import './styles/tokens.css'
import './styles/base.css'
import './styles/shell.css'
import './styles/components.css'
import './styles/grade.css'
import './styles/ligado.css'

import App from './App'
import { FormularioPublico } from './telas/FormularioPublico'

const raiz = document.getElementById('root')
if (!raiz) throw new Error('#root nao encontrado em index.html')

// O link que o professor recebe (P12). Fora do App de propósito: não há
// sessão, menu nem projeto — só o formulário dele.
const tokenDoFormulario = new URLSearchParams(location.search).get('formulario')

createRoot(raiz).render(
  <StrictMode>{tokenDoFormulario ? <FormularioPublico token={tokenDoFormulario} /> : <App />}</StrictMode>,
)
